export function getBuildID() {
  return process.env.FRONTEND_BUILD_ID
}
